import { API_ENDPOINT } from "@/constants/appConstants";
import { RECOMMENDED_JOBS_QUERY_KEY } from "@/lib/queryKeys";
import {
  UseInfiniteQueryResult,
  useInfiniteQuery,
} from "@tanstack/react-query";

import { RecommendedJobAPIKeysType } from "./types";

export const recommendedJobAPI = async (
  filterUuid?: string,
  pageParam: number = 1,
  limit: number = 10,
  quickApplyFilter: boolean = false,
): Promise<RecommendedJobAPIKeysType> => {
  try {
    const host = window.location.host;
    const response = await fetch(
      `${API_ENDPOINT(host).middleware.getCategorizedJobs}?${filterUuid ? `categoryField=${filterUuid}&` : ""}start=${(pageParam - 1) * limit}&limit=${limit}`,
      {
        method: "GET",
        credentials: "include",
      },
    );

    if (!response.ok) {
      throw new Error(
        `Error fetching page ${pageParam}: ${response.statusText}`,
      );
    }

    const data: RecommendedJobAPIKeysType = await response.json();
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    } else {
      throw new Error(
        `Error occurred while fetching data, ${JSON.stringify(error)}`,
      );
    }
  }
};

export const useRecommendedJobs = (
  filterStatus: string,
  enableToggle: boolean,
  initialPage: number,
  quickApplyFilter: boolean,
): UseInfiniteQueryResult<{ pages: RecommendedJobAPIKeysType[] }> => {
  return useInfiniteQuery({
    queryKey: [
      RECOMMENDED_JOBS_QUERY_KEY,
      filterStatus,
      initialPage,
      quickApplyFilter,
    ],
    queryFn: ({ pageParam }) => {
      return recommendedJobAPI(filterStatus, pageParam, 10, quickApplyFilter);
    },
    getNextPageParam: (lastPage, allPages) => {
      const currentPage =
        initialPage == 2 ? allPages.length + 1 : allPages.length;
      return currentPage + 1;
    },
    retry: 1,
    initialPageParam: initialPage,
    enabled: enableToggle,
  });
};
